<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12">
      <div class="card shadow-lg">
        <div class="card-header bg-primary text-white text-center">
          <h3>{{ isEditMode ? 'Edit Department' : 'Create New Department' }}</h3>
        </div>
        <div class="card-body">
          <form #depForm="ngForm" (ngSubmit)="onSubmit()">

            <fieldset readOnlyIfNoGroupPermissionDirective>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="name" class="form-label">Name</label>
                <i-tooltip tooltip="department.Name"></i-tooltip>
                <input type="text" id="name" class="form-control" [(ngModel)]="department.name" name="name" required
                  autofocus appAutoFocus />
              </div>
              <div class="col-md-6 mb-3">
                <label for="phoneNumber" class="form-label">Phone Number</label>
                <i-tooltip tooltip="department.phoneNumber"></i-tooltip>
                <input type="tel" id="phoneNumber" class="form-control" [(ngModel)]="department.phoneNumber"
                  name="phoneNumber" />
              </div>
            </div>

            <div class="mb-3">
              <label for="serviceDescription" class="form-label">Service Description</label>
              <i-tooltip tooltip="department.serviceDescription"></i-tooltip>
              <textarea id="serviceDescription" class="form-control" rows="3"
                [(ngModel)]="department.serviceDescription" name="serviceDescription" required></textarea>
              <button type="button" class="btn btn-primary mt-2" (click)="playText(department.serviceDescription)">
                Play Service Description
              </button>
            </div>

            <div class="mb-3">
              <label for="outOfHoursMessage" class="form-label">Out of Hours Message</label>
              <i-tooltip tooltip="department.outOfHoursMessage"></i-tooltip>
              <textarea id="outOfHoursMessage" class="form-control" rows="3" [(ngModel)]="department.outOfHoursMessage"
                name="outOfHoursMessage"></textarea>
              <button type="button" class="btn btn-primary mt-2" (click)="playText(department.outOfHoursMessage)">
                Play Out of Hours Message
              </button>
            </div>
            <audio #audioPlayer></audio>

            <div class="row">
              <!-- Fallback Department -->
              <div class="mb-4 col">
                <label class="form-label">Out of Hours Fallback Department</label>
                <i-tooltip tooltip="department.outOfHoursFallbackDepartmentId"></i-tooltip>
                <select class="form-select" [(ngModel)]="department.outOfHoursFallbackDepartmentId"
                  name="fallbackDepartmentId">
                  <option [ngValue]="null">None</option>
                  <option *ngFor="let dept of departments" [value]="dept.id">{{ dept.name }}</option>
                </select>
              </div>
            </div>


            <div class="mb-3">
              <label for="alternativeNames" class="form-label">Alternative Names</label>
              <textarea id="alternativeNames" class="form-control" name="alternativeNamesText" rows="3"
                [(ngModel)]="alternativeNamesText" placeholder="Enter each name on a new line"></textarea>
            </div>


            <div class="mb-3">
              <label for="escalationTeam" class="form-label">Escalation Team</label>

              <p-multiselect [disabled]="!hasPermission" [options]="availableEntities" [(ngModel)]="department.escalationTeam" virtualScroll="true"
                filter="true" optionLabel="description" placeholder="Select Escalation" [maxSelectedLabels]="3"
                styleClass="w-100 md:w-80" showClear="true" display="chip" scrollHeight="400px"
                virtualScrollItemSize="75" name="escalationTeam" [loading]="isLoadingTeam">

                <ng-template #dropdownicon>
                  <i class="pi pi-list"></i>
                </ng-template>

                <ng-template #header>
                  <div class="bg-primary text-white p-2 text-center">Select Entities
                  </div>
                </ng-template>

                <ng-template let-intent #item>
                  <div class="d-flex flex-column">
                    <strong>{{ intent.description }}</strong>
                    <div class="text-muted small">{{ intent.qualifiedName }}</div>
                    <div class="small fst-italic text-secondary">Q: {{
                      intent.sampleQuestion }}
                    </div>
                    <div class="small text-success">A: {{ intent.sampleAnswer }}</div>
                  </div>
                </ng-template>
              </p-multiselect>
            </div>


            <!-- Opening Times Section -->
            <h5 class="mt-4">Opening Times</h5>

            <div class="mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" role="switch" type="checkbox"
                  [(ngModel)]="department.ignorePublicHolidays" id="ignorePublicHolidays" name="ignorePublicHolidays">
                <label for="ignorePublicHolidays" class="form-check-label">Ignore Public Holidays</label>
              </div>
            </div>

            <div class="row">
              <div *ngFor="let day of daysOfWeek" class="col-md-8 col-lg-6 mb-6">
                <div class="card shadow-sm">
                  <div class="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                    <strong>{{ day }}</strong>
                    <!-- Dropdown Buttons -->
                    <div>
                      <!-- Copy Dropdown -->
                      <div class="btn-group me-1">
                        <button type="button" class="btn btn-sm btn-outline-light dropdown-toggle"
                          data-bs-toggle="dropdown">
                          <i class="bi bi-clipboard"></i> Copy From
                        </button>
                        <ul class="dropdown-menu">
                          <li *ngFor="let otherDay of getOtherDays(day)">
                            <a class="dropdown-item" href="javascript:void(0)"
                              (click)="copyTimeSlots(day, otherDay, department.openingTimes.slots)">
                              {{ otherDay }}
                            </a>
                          </li>
                        </ul>
                      </div>

                      <!-- Clone Dropdown -->
                      <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-outline-light dropdown-toggle"
                          data-bs-toggle="dropdown">
                          <i class="bi bi-arrow-clockwise"></i> Clone To
                        </button>
                        <ul class="dropdown-menu">
                          <li *ngFor="let otherDay of getOtherDays(day)">
                            <a class="dropdown-item" href="javascript:void(0)"
                              (click)="cloneTimeSlots(day, otherDay, department.openingTimes.slots)">
                              {{ otherDay }}
                            </a>
                          </li>
                          <li>
                            <hr class="dropdown-divider">
                          </li>
                          <li>
                            <a class="dropdown-item" href="javascript:void(0)"
                              (click)="cloneToWeekdays(day, department.openingTimes.slots)">
                              Weekdays
                            </a>
                          </li>
                          <li>
                            <a class="dropdown-item" href="javascript:void(0)"
                              (click)="cloneToWeekend(day, department.openingTimes.slots)">
                              Weekends
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div *ngFor="let slot of department.openingTimes.slots[day]; let i = index"
                      class="input-group mb-2">

                      <span class="input-group-text">Start</span>
                      <input type="time" step="1" [(ngModel)]="slot.start" name="{{day}}-start-{{i}}"
                        class="form-control" />

                      <span class="input-group-text">End</span>
                      <input type="time" step="1" [(ngModel)]="slot.end" name="{{day}}-end-{{i}}"
                        class="form-control" />

                      <button type="button" class="btn btn-outline-danger"
                        (click)="removeTimeSlot(day, i, department.openingTimes.slots)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                    <button type="button" class="btn btn-sm btn-link text-primary"
                      (click)="addTimeSlot(day, department.openingTimes.slots)">
                      + Add Time Slot
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <h5 class="mt-4">Schedule Periods</h5>
            <div class="card shadow-sm">
              <div class="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <span>Manage Schedule Periods</span>
                <button type="button" class="btn btn-sm btn-light" (click)="addNewPeriod(periodModal)">+ Add
                  Period</button>
              </div>
              <div class="card-body">
                <div class="list-group">
                  <div *ngFor="let period of department.schedulePeriods"
                    class="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                      <strong>{{ period.title }}</strong> <br>
                      <small>{{ period.startDateTime | date:'short' }} - {{ period.endDateTime | date:'short' }}</small>
                      <p *ngIf="period.isApplied" class="text-success m-0">Active</p>
                    </div>
                    <div>
                      <button type="button" class="btn btn-sm btn-primary me-2"
                        (click)="editPeriod(periodModal, period)">Edit</button>
                      <button type="button" class="btn btn-sm btn-danger" (click)="deletePeriod(period)">Delete</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            </fieldset>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-center mt-4">
              <button type="submit"  [disabled]="depForm.invalid"  class="btn btn-primary me-2" readOnlyIfNoGroupPermissionDirective [showToastWhenRendering]="false">
                {{ isEditMode ? 'Save Changes' : 'Create Department' }}
              </button>
              <button type="button" class="btn btn-secondary" (click)="cancel()" showOnReadOnly="true">Cancel</button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #periodModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ isScheduleEditMode ? 'Edit Schedule Period' : 'Add New Schedule Period' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body" *ngIf="selectedPeriod">
    <!-- SchedulePeriodFormComponent Layout -->
    <form (ngSubmit)="saveSchedulePeriod(modal)" #schedulePeriodForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="title" class="form-label">Title</label>
          <input type="text" id="title" class="form-control" [(ngModel)]="selectedPeriod.title" name="title" required />
        </div>
        <div class="col-md-6 mb-3">
          <label for="phoneNumber" class="form-label">Phone Number</label>
          <input type="tel" id="phoneNumber" class="form-control" [(ngModel)]="selectedPeriod.phoneNumber"
            name="phoneNumber" />
        </div>
      </div>

      <div class="mb-3">
        <label for="serviceDescription" class="form-label">Service Description</label>
        <textarea id="serviceDescription" class="form-control" rows="3" [(ngModel)]="selectedPeriod.serviceDescription"
          name="serviceDescription"></textarea>
        <button type="button" class="btn btn-outline-dark mt-2" (click)="playText(selectedPeriod.serviceDescription)">
          Play Service Description
        </button>
      </div>

      <div class="mb-3">
        <label for="outOfHoursMessage" class="form-label">Out of Hours Message</label>
        <textarea id="outOfHoursMessage" class="form-control" rows="3" [(ngModel)]="selectedPeriod.outOfHoursMessage"
          name="outOfHoursMessage"></textarea>
        <button type="button" class="btn btn-outline-dark mt-2" (click)="playText(selectedPeriod.outOfHoursMessage)">
          Play Out of Hours Message
        </button>
      </div>

      <div class="row">
        <!-- Fallback Department -->
        <div class="mb-4 col">
          <label class="form-label">Out of Hours Fallback Department</label>
          <select class="form-select" [(ngModel)]="selectedPeriod.outOfHoursFallbackDepartmentId"
            name="fallbackDepartmentId">
            <option [ngValue]="null">None</option>
            <option *ngFor="let dept of departments" [value]="dept.id">{{ dept.name }}</option>
          </select>
        </div>
      </div>


      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="startDateTime" class="form-label">Start Date & Time</label>
          <input type="datetime-local" id="startDateTime" class="form-control"
            [(ngModel)]="selectedPeriod.startDateTime" name="startDateTime" required />
        </div>
        <div class="col-md-6 mb-3">
          <label for="endDateTime" class="form-label">End Date & Time</label>
          <input type="datetime-local" id="endDateTime" class="form-control" [(ngModel)]="selectedPeriod.endDateTime"
            name="endDateTime" required />
        </div>
      </div>

      <!-- Opening Times Section -->
      <h5 class="mt-4">Opening Times</h5>

      <div class="mb-3">
        <div class="form-check form-switch">
          <input class="form-check-input" role="switch" type="checkbox"
            [(ngModel)]="selectedPeriod.ignorePublicHolidays" id="ignorePublicHolidays" name="ignorePublicHolidays">
          <label for="ignorePublicHolidays" class="form-check-label">Ignore Public Holidays</label>
        </div>
      </div>

      <div class="row">
        <div *ngFor="let day of daysOfWeek" class="col-md-8 col-lg-6 mb-6">
          <div class="card shadow-sm">
            <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <strong>{{ day }}</strong>
              <div>
                <!-- Copy Dropdown -->
                <div class="btn-group me-1">
                  <button type="button" class="btn btn-sm btn-outline-light dropdown-toggle" data-bs-toggle="dropdown">
                    <i class="bi bi-clipboard"></i> Copy From
                  </button>
                  <ul class="dropdown-menu">
                    <li *ngFor="let otherDay of getOtherDays(day)">
                      <a class="dropdown-item" href="javascript:void(0)"
                        (click)="copyTimeSlots(day, otherDay, selectedPeriod.openingTimes.slots)">
                        {{ otherDay }}
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- Clone Dropdown -->
                <div class="btn-group">
                  <button type="button" class="btn btn-sm btn-outline-light dropdown-toggle" data-bs-toggle="dropdown">
                    <i class="bi bi-arrow-clockwise"></i> Clone To
                  </button>
                  <ul class="dropdown-menu">
                    <li *ngFor="let otherDay of getOtherDays(day)">
                      <a class="dropdown-item" href="javascript:void(0)"
                        (click)="cloneTimeSlots(day, otherDay, selectedPeriod.openingTimes.slots)">
                        {{ otherDay }}
                      </a>
                    </li>
                    <li>
                      <hr class="dropdown-divider">
                    </li>
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)"
                        (click)="cloneToWeekdays(day, selectedPeriod.openingTimes.slots)">
                        Weekdays
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)"
                        (click)="cloneToWeekend(day, selectedPeriod.openingTimes.slots)">
                        Weekends
                      </a>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div *ngFor="let slot of selectedPeriod.openingTimes.slots[day]; let i = index" class="input-group mb-2">
                <span class="input-group-text">Start</span>
                <input type="time" step="1" [(ngModel)]="slot.start" name="{{day}}-start-{{i}}" class="form-control" />
                <span class="input-group-text">End</span>
                <input type="time" step="1" [(ngModel)]="slot.end" name="{{day}}-end-{{i}}" class="form-control" />
                <button type="button" class="btn btn-outline-danger"
                  (click)="removeTimeSlot(day, i, selectedPeriod.openingTimes.slots)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
              <button type="button" class="btn btn-sm btn-link text-primary"
                (click)="addTimeSlot(day, selectedPeriod.openingTimes.slots)">
                + Add Time Slot
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
        <button type="submit" [disabled]="schedulePeriodForm.invalid" class="btn btn-primary">{{ isScheduleEditMode ?
          'Save Changes' : 'Create Schedule Period' }}</button>
      </div>
    </form>
  </div>
</ng-template>